export default __webpack_public_path__ + "static/media/arbeitskleidung.59fefea2.jpg";